export default "__VITE_ASSET__CMiWc6J2__"